<ng-container *ngIf="objectIdentifier">

    <!-- Show Object -->
    <mvs-pc-call [objectIdentifier]="objectIdentifier"></mvs-pc-call>

</ng-container>
